module.exports = __webpack_public_path__ + "img/2015025.3af79ca8.svg";